import { create } from 'zustand'

/*
mobile menu has 3 states
desktop only two - desktop menu is never closed

mobile menu is closed by default on both routes

on settings route:
- opening mobile menu should open secondaryMobile
- on desktop secondaryDesktop should be opened by default

on projects route:
- opening mobile menu should open primaryMobile
- on desktop primaryDesktop should be opened by default
*/

export type MobileMenuLayerT = 'primaryMobile' | 'secondaryMobile'
export type DesktopMenuLayerT = 'primaryDesktop' | 'secondaryDesktop'
export type MobileMenuStateT = 'closedMobile' | 'primaryMobile' | 'secondaryMobile'
export type DesktopMenuStateT = 'primaryDesktop' | 'secondaryDesktop'
export type MainRouteT = 'projectStages' | 'settings'

type UseMenuStoreT = {
  mobileMenuState: MobileMenuStateT
  desktopMenuState: DesktopMenuStateT
  openMobileMenu: (mainRoute: MainRouteT) => void
  closeMobileMenu: () => void
  openSecondaryMenu: () => void
  openSecondaryDesktopMenu: () => void
  closeSecondaryDesktopMenu: () => void
  closeSecondaryMenu: () => void
}

export const useMenuStore = create<UseMenuStoreT>(set => ({
  mobileMenuState: 'closedMobile',
  desktopMenuState: 'primaryDesktop',
  openMobileMenu: (mainRoute: MainRouteT) =>
    set(() => {
      document.body.style.overflow = 'hidden'
      return {
        mobileMenuState: mainRoute === 'settings' ? 'secondaryMobile' : 'primaryMobile',
      }
    }),
  closeMobileMenu: () =>
    set(() => {
      document.body.style.overflow = 'unset'
      return { mobileMenuState: 'closedMobile' }
    }),
  openSecondaryMenu: () => {
    set({
      mobileMenuState: 'secondaryMobile',
      desktopMenuState: 'secondaryDesktop',
    })
  },
  openSecondaryDesktopMenu: () => {
    set({
      desktopMenuState: 'secondaryDesktop',
    })
  },
  closeSecondaryDesktopMenu: () => {
    // Only restore the primary DESKTOP layer. Leave mobile state untouched —
    // the mobile drawer has its own lifecycle (open/close via toggle button).
    set({
      desktopMenuState: 'primaryDesktop',
    })
  },
  closeSecondaryMenu: () => {
    set({
      mobileMenuState: 'primaryMobile',
      desktopMenuState: 'primaryDesktop',
    })
  },
}))


type MenuSelectStoreT = {
  selectedOrganization: string | null
  setSelectedOrganization: (value: string | null) => void
  navigationSelectState: 'closed' | 'open'
  navigationSelectSelectedScope: 'projects' | 'organizations' | 'lang'
  openProjectsSelect: () => void
  openOrganizationsSelect: () => void
  closeNavigationSelect: () => void
  openNavigationSelect: () => void
}

export const useMenuSelectStore = create<MenuSelectStoreT>(set => ({
  selectedOrganization: null,
  setSelectedOrganization: value => set({ selectedOrganization: value }),
  navigationSelectState: 'closed',
  navigationSelectSelectedScope: 'projects',
  openProjectsSelect: () =>
    set({ navigationSelectState: `open`, navigationSelectSelectedScope: `projects` }),
  openOrganizationsSelect: () =>
    set({ navigationSelectState: `open`, navigationSelectSelectedScope: `organizations` }),
  closeNavigationSelect: () => set({ navigationSelectState: 'closed' }),
  openNavigationSelect: () => set({ navigationSelectState: 'open' }),
}))
